import { Options } from "@/components/Common/Selects/Select.types";
import { create } from "zustand";

type StatusLessonModuleStore = {
  selectedStatusValues: Options[];
  setSelectedStatusValues: (statusValues: Options[]) => void;
};


export const useStatusLessonModuleStore = create<StatusLessonModuleStore>((set) => ({
  selectedStatusValues: [],
  setSelectedStatusValues: (statusValues) => set({ selectedStatusValues: statusValues }),
}));



